// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28Cn-","tabsBox":"styles_tabsBox__3vsXr","createButton":"styles_createButton__2cN5o"};